<template>
<div class="container-wrapper">
  <div class="margin">
    <h1 v-if="title" class="title is-1 is-margin-header">{{ title }}</h1>
    <h1 :class="getSubtitleClass" v-if="subtitle">
      {{ getSubtitle }}
      <slot></slot>
    </h1>
  </div>
  <div v-if="widget" class="tabs" >
    <ul v-if="tabItems && tabItems.length > 0">
      <li v-for="(item) in tabItems"
          :key="item"
          :class="{ 'is-active': activeItem === item }"
          :style="activeItem === item ? isActive : {}"
      >
        <a href="#" @click.prevent="onNavItemClick(item)">
          {{item}}
        </a>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import {MUNDO_CRYPTO} from '../constants/jobboards-ids'
import {mapState} from 'vuex'

export default {
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String,
      default: ''
    },
    extension: {
      type: String,
      default: () => null
    },
    widget: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tabItems: ['EN', 'ES'],
    activeItem: 'EN'

  }),
  computed: {
    ...mapState('widgetStyles', ['activeNav']),
    isActive () {
      return this.activeNav
    },
    getSubtitle () {
      if (this.subtitle === 'Jobs') {
        return this.$t('widget.jobs')
      } else if (this.subtitle === 'Companies') {
        return this.$t('widget.companies')
      } else if (this.subtitle === 'Talent') {
        return this.$t('widget.talent')
      }
      return this.subtitle
    },
    getSubtitleClass () {
      const url = this.$route.fullPath
      return url.split('/')[url.split('/').length - 1] === MUNDO_CRYPTO ? 'subtitle mun-light is-1' : 'subtitle mundo-light is-1'
    }
  },
  mounted () {
    const current = this.$localStorage.get('locale')
    this.activeItem = current.toUpperCase()
    this.onChangeLang()
  },
  methods: {
    onChangeLang () {
      this.$i18n.locale = this.activeItem.toLowerCase()
      this.$localStorage.set('locale', this.activeItem.toLowerCase())
    },
    onNavItemClick (item) {
      this.activeItem = item
      this.onChangeLang()
    }
  }
}
</script>

<style lang="scss" scoped>
.margin {
  & > h1 {
    font-weight: 600;
    &.subtitle {
      color: black;
    }
  }
  margin-top: 1rem;

}
.title.is-margin-header {
  color: #c7c7c7;
}

@media (max-width: 400px) {
  .title{
    font-size: 2rem;
    font-weight: 800;
  }
  .subtitle{
    font-size: 2rem;
    font-weight: 800;
  }
}

.container-wrapper{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/margin-title.vue